var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("notifications", { attrs: { group: "foo" } }),
      _c("AmaLink"),
      !_vm.checkOnRouteBanner() && _vm.start ? _c("search-bar") : _vm._e(),
      _vm.start ? _c("router-view") : _vm._e(),
      !_vm.isAma ? _c("Footer") : _vm._e(),
      _vm.isAma ? _c("FooterAma") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }